module.exports = __webpack_public_path__ + "img/stepTraining.71302afc.png";